if (!customElements.get('geosort-story-video')) {
  customElements.define('geosort-story-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches;
      this.blocked = false;
      this.inView = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.userPaused = this.blocked ? false : !this.userPaused;
        this.blocked = false;
        this.update();
      }, options);
      this.video.addEventListener('playing', () => {
        this.video.classList.add('is-playing');
        this.blocked = false;
        this.updateControl();
      }, options);
      this.video.addEventListener('error', () => {
        this.blocked = true;
        this.video.classList.remove('is-playing');
        this.updateControl();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.05 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.motion.addEventListener('change', () => {
        this.userPaused = this.motion.matches;
        this.update();
      }, options);
      this.updateControl();
    }
    updateControl() {
      const paused = this.userPaused || this.blocked;
      this.button.setAttribute('aria-pressed', String(paused));
      this.button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} ${this.dataset.brand} video`);
      this.button.querySelector('[data-pause-icon]').hidden = paused;
      this.button.querySelector('[data-play-icon]').hidden = !paused;
    }
    update() {
      this.updateControl();
      if (!this.inView || this.userPaused || document.hidden || this.closest('[hidden],[inert]')) {
        this.video.pause();
        return;
      }
      if (this.pending || this.blocked || !this.video.paused) return;
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.muted = true;
      this.pending = this.video.play();
      this.pending.catch(error => {
        // Scrolling away can cancel play while the file is loading; it is not a user pause.
        if (error.name !== 'AbortError') this.blocked = true;
      }).finally(() => {
        this.pending = null;
        if (!this.abort) return;
        this.updateControl();
        if (!this.blocked) this.update();
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
